import { computed, reactive } from 'vue'
import { defineStore } from 'pinia'
import router from '@/router'
// 标签页
export const navStore = defineStore('nav', () => {
  const session = sessionStorage.getItem('navArr') || '[]'
  const navArr = reactive(JSON.parse(session))
  function addNav(routes: object) {
    if (
      routes.name !== 'login' &&
      !navArr.find((item) => item.name === routes.name)
    )
      navArr.push({
        name: routes.name,
        path: routes.path,
        meta: routes.meta
      })
    const navArrTemp = navArr.filter((item, index) => item.name !== 'Map')
    navArrTemp.unshift({
      name: 'Map',
      path: '/map',
      meta: { title: 'router.map' }
    })
    sessionStorage.setItem('navArr', JSON.stringify(navArrTemp))
  }
  function removeNav(routes: object) {
    const index = navArr.findIndex((item) => item.name === routes.name)
    if (index !== -1) {
      navArr.splice(index, 1)
      // 当前页删除标签则回退
      if (router.currentRoute.value.name === routes.name) {
        if (navArr.length > 0) router.replace(navArr[index - 1].path)
        sessionStorage.setItem('navArr', JSON.stringify(navArr))
      } //不在当前页删除标签
      else {
        if (navArr.length > 0) router.replace(navArr[index - 1].path)
        sessionStorage.setItem('navArr', JSON.stringify(navArr))
      }
    }
  }
  function removeExptIndex(routes: object) {
    const index = navArr.findIndex((item) => item.name === routes.name)
    if (index !== -1) {
      navArr.splice(index, 1)
      // 当前页删除标签则回退
      if (router.currentRoute.value.name === routes.name) {
        if (navArr.length > 0) router.replace('index')
        sessionStorage.setItem('navArr', JSON.stringify(navArr))
      } //不在当前页删除标签
      else {
        if (navArr.length > 0) router.replace('index')
        sessionStorage.setItem('navArr', JSON.stringify(navArr))
      }
    }
  }
  // 当前缓存的组件
  const keepAliveList = computed(() => {
    return navArr.map((item) => item.name)
  })
  return { navArr, addNav, removeNav, removeExptIndex, keepAliveList }
})
